import { useState, useEffect } from 'react';
import { holidayApi } from '../services/api';
import { toast } from 'sonner';

export function useHolidays() {
  const [holidays, setHolidays] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const loadHolidays = async (params) => {
    try {
      setLoading(true);
      setError(null);
      const response = await holidayApi.getAll(params);
      if (response.success && response.data) {
        setHolidays(response.data);
      } else {
        throw new Error(response.message || 'Error al cargar festivos');
      }
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Error desconocido';
      setError(errorMessage);
      toast.error('Error al cargar festivos: ' + errorMessage);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadHolidays({ year: new Date().getFullYear() });
  }, []);

  const addHoliday = async (holidayData) => {
    const response = await holidayApi.create(holidayData);
    if (response.success && response.data) {
      setHolidays(prev => [...prev, response.data].sort((a, b) => new Date(a.date) - new Date(b.date)));
      toast.success(response.message || 'Festivo agregado exitosamente');
      return response.data;
    }
    throw new Error(response.message || 'Error al agregar festivo');
  };

  const updateHoliday = async (id, updates) => {
    const response = await holidayApi.update(id, updates);
    if (response.success && response.data) {
      setHolidays(prev => prev.map(h => h.id === id ? response.data : h));
      toast.success(response.message || 'Festivo actualizado exitosamente');
      return response.data;
    }
    throw new Error(response.message || 'Error al actualizar festivo');
  };

  const removeHoliday = async (id) => {
    const response = await holidayApi.delete(id);
    if (response.success) {
      setHolidays(prev => prev.filter(h => h.id !== id));
      toast.success(response.message || 'Festivo eliminado exitosamente');
      return true;
    }
    throw new Error(response.message || 'Error al eliminar festivo');
  };

  const calculateWorkingDays = async (startDate, endDate) => {
    try {
      const response = await holidayApi.calculateWorkingDays(startDate, endDate);
      console.log('Respuesta completa de calculateWorkingDays:', response);
      
      if (response && response.success && response.data) {
        return {
          success: true,
          data: {
            workingDays: response.data.workingDays,
            startDate: response.data.startDate,
            endDate: response.data.endDate
          }
        };
      } else {
        console.error('Respuesta inesperada de calculateWorkingDays:', response);
        return {
          success: false,
          data: { workingDays: 0 }
        };
      }
    } catch (error) {
      console.error('Error en calculateWorkingDays:', error);
      toast.error('Error al calcular días hábiles: ' + error.message);
      return {
        success: false,
        data: { workingDays: 0 }
      };
    }
  };

  const generateRecurringHolidays = async (year) => {
    const response = await holidayApi.generateRecurringHolidays(year);
    if (response.success && response.data) {
      await loadHolidays({ year });
      toast.success(response.message || `Festivos generados para ${year}`);
      return response.data;
    }
    throw new Error(response.message || 'Error al generar festivos recurrentes');
  };

  return {
    holidays,
    loading,
    error,
    loadHolidays,
    addHoliday,
    updateHoliday,
    removeHoliday,
    calculateWorkingDays,
    generateRecurringHolidays
  };
}
